export default class UserMapping {

    mapData(competency) {
        return {
            id: competency ? competency.id : null,
            name_en: competency ? competency.name_en : null,
            name_fr: competency ? competency.name_fr : null,
            active: competency ? competency.active : true,
            position: competency ? competency.position : 0,
            domain_id: competency ? competency.domain_id : null,
            domain: competency ? competency.domain : null,
        }
    }

    unmapData(data) {
        return data
    }
}
